import {createAction} from '@reduxjs/toolkit'

export const collapseDescription = createAction<string>('TICKETS_PICKER_COLLAPSE_DESCRIPTION')

export const expandDescription = createAction<string>('TICKETS_PICKER_EXPAND_DESCRIPTION')
